<template>
  <img
    v-if="resolvedLogoUrl && !loadFailed"
    :src="resolvedLogoUrl"
    :style="logoStyle"
    class="airline-logo"
    alt=""
    @error="loadFailed = true"
  />
</template>

<script>
export default {
  name: 'AirlineLogo',
  props: {
    airline: {
      type: Object,
      default: null,
    },
    size: {
      type: Number,
      default: 24,
      validator: value => value > 0,
    },
  },
  data() {
    return {
      loadFailed: false,
    }
  },
  computed: {
    resolvedLogoUrl() {
      const logoUrl = this.airline && this.airline.logo_url
      if (!logoUrl || typeof logoUrl !== 'string') return ''
      try {
        const browserOrigin = typeof window === 'undefined' ? 'http://localhost' : window.location.origin
        const apiOrigin = new URL(process.env.VUE_APP_API_URL || browserOrigin, browserOrigin).origin
        const resolved = new URL(logoUrl, `${apiOrigin}/`)
        return ['http:', 'https:'].includes(resolved.protocol) ? resolved.href : ''
      } catch (error) {
        return ''
      }
    },
    logoStyle() {
      return {
        maxHeight: `${this.size}px`,
        maxWidth: '70px',
      }
    },
  },
  watch: {
    resolvedLogoUrl() {
      this.loadFailed = false
    },
  },
}
</script>

<style lang="sass" scoped>
.airline-logo
  display: block
  flex: 0 1 auto
  width: auto
  height: auto
  border: 0
  background: transparent
  object-fit: contain
  object-position: left center
</style>
